export const READ_ONLY_BACKGROUND_COLOR = 'hoverTransparentLight';
